import DownloadReport from './DownloadReport';

export default DownloadReport;
